<template>
    <div class="content">
        <div class="title">IFM考试</div>
        <div class="list">
            <div v-for="(item, index) in ifmExamObj" :key="index" class="card" @click="go(item)">
                <img :src="item.image">
                <div class="card-content">
                    <div class="title">{{item.title}}</div>
                    <div class="info">{{item.intro}}</div>
                    <div class="time">{{item.date}}</div>
                </div>
                
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    computed: mapState([
        'ifmExamObj'
    ]),
    data() {
        return {
            arr:[
                {title:'IFM职业资格考试',img:'',content:'国际财务管理师（International Finance Manager简称IFM）是国际财务管理专业领域的',time:'2020-07-07'},
                {title:'认证管理制度',img:'',content:'此规定同时适用于四个级别的国际财务管理师（EIFM、AIFM、IFM、SIFM）',time:'2020-07-07'},
                {title:'补考安排',img:'',content:'此规定同时适用于四个级别的国际财务管理师（EIFM、AIFM、IFM、SIFM）',time:'2020-07-07'},
                {title:'业界评价',img:'',content:'国际财务管理协会与中国总会计师协会联合认证“国际财务管理师”是一项适应全球经',time:'2020-07-07'},
            ]
        }
    },
    methods: {
        go(item){
            this.$router.push(item.url);
        }
    },
}
</script>
<style lang="scss" scoped>
.content{
    width:1120px;
    margin:auto;
    box-sizing: border-box;
    padding: 30px;
    background: #fff;
    .title{
        font-size: 22px;
        color: #235483;
        letter-spacing: 0.62px;
        font-weight: 600;
    }
    .list{
        width:100%;
        display: flex;
        margin-top: 25px;
        .card{
            background: #F0F0F0;
            width:240px;
            margin-right: 30px;
            cursor: pointer;
            img{
                height:130px;
                width:100%;
            }
            .card-content{
                box-sizing: border-box;
                padding: 15px 15px 28px 20px;
                .title{
                    font-size: 16px;
                    color: #333333;
                    letter-spacing: 0.45px;
                    font-weight: 600;
                    margin-bottom: 13px;
                }
                .info{
                    font-size: 14px;
                    color: #333333;
                    letter-spacing: 0.4px;
                    font-weight: 400;
                    margin-bottom: 12px;
                }
                .time{
                    font-size: 14px;
                    color: #3B3B3B;
                    letter-spacing: 0.4px;
                    font-weight: 400;
                }
            }
        }
    }
}
</style>
